import {
  FaBug,
  FaNetworkWired,
  FaShieldAlt,
  FaLaptopCode,
  FaCheckCircle,
  FaArrowRight,
} from "react-icons/fa";
import CurriculumCard from "./CurriculumCard";
import cyberSecurityImage from "../../assets/img/curriculum/Cyber Security.jpg";

import ProgressBar from "./Progress-bar";

export default function CurriculumSection() {
  return (
    <section className="bg-white py-24">
      <div className="mx-auto lg:px-28 md:px-14 px-6">
        <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
          <div className="max-w-2xl">
            <h2 className="font-black leading-tight text-[#12105E] text-2xl md:text-4xl lg:text-4xl">
              Comprehensive <br /> Curriculum
            </h2>

            <p className="mt-4 text-base text-slate-500 sm:text-lg">
              We take you from Zero to Hero through our structured learning
              modules.
            </p>
          </div>

          <div className="flex justify-start lg:justify-end">
            <a
              href={cyberSecurityImage}
              download="Cyber Security.jpg"
              className="
        w-fit
        rounded-xl
        border
        border-amber-200
        bg-amber-50
        px-4
        py-3
        text-[10px]
        font-bold
        uppercase
        tracking-[0.2em]
        text-amber-700
        sm:px-5
        sm:text-xs
        whitespace-nowrap
        inline-flex
        items-center
        justify-center
      "
            >
              Industry Standard
            </a>
          </div>
        </div>

        <div className="mt-16 grid gap-6 lg:grid-cols-12">
          <CurriculumCard
            className="lg:col-span-8"
            title="Offensive/Defensive Security"
            description="Learn the mindset of an attacker to better defend your systems. You'll master vulnerability assessment, simulate attacks and defense techniques."
            icon={FaBug}
            iconClassName="flex h-14 w-14 items-center justify-center rounded-2xl bg-gradient-to-br from-blue-600 to-amber-600 text-white"
          >
            <div className="mt-8 grid grid-cols-2 gap-4">
              {[
                "Bug Bounties",
                "Metasploit",
                "Web Apps",
                "Social Engineering",
              ].map((item) => (
                <div
                  key={item}
                  className="flex items-center gap-2 text-sm"
                >
                  <FaCheckCircle className="text-blue-600" />
                  {item}
                </div>
              ))}
            </div>
          </CurriculumCard>

          <CurriculumCard
            className="lg:col-span-4"
            title="Network Security"
            description="Master firewall configuration, VPNs, and wireless security."
            icon={FaNetworkWired}
            iconClassName="flex h-14 w-14 items-center justify-center rounded-2xl bg-blue-50 text-blue-600"
          >
            <div className="mt-8 space-y-3">
              <ProgressBar value={95} />
              <ProgressBar value={70} />
              <ProgressBar value={92} />
            </div>
          </CurriculumCard>

          <CurriculumCard
            className="lg:col-span-4"
            title="Threat Detection"
            description="Learn real-time monitoring and incident response using SIEM tools."
            icon={FaShieldAlt}
            iconClassName="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-700"
          ></CurriculumCard>

          <CurriculumCard
            className="lg:col-span-8"
            title="Practical Sessions"
            description="No boring theories. 100% lab-based training where you interact with live targets in a safe environment."
            icon={FaLaptopCode}
            iconClassName="flex h-14 w-14 items-center justify-center rounded-2xl bg-slate-100 text-blue-400"
          >
            <div className="flex items-center justify-between gap-8">
              <div>
                <a
                  href={cyberSecurityImage}
                  download="Cyber Security.jpg"
                  className="mt-4 inline-flex items-center font-semibold text-blue-600 hover:text-blue-700"
                >
                  View Full Curriculum
                  <FaArrowRight className="ml-2" />
                </a>
              </div>

              <div
                className="
                  flex
                  h-36
                  w-36
                  items-center
                  justify-center
                  rounded-2xl
                  bg-slate-100
                  text-5xl
                  text-blue-400
                "
              >
                <FaLaptopCode />
              </div>
            </div>
          </CurriculumCard>
        </div>
      </div>
    </section>
  );
}
